export default __webpack_public_path__ + "static/viinitie-banner-xmass-mobile.3d9be63e296ebcb3fce9ea278dfc2890.jpg";